import { ReactNode } from 'react';
import { SxProps, Theme, Typography } from '@mui/material';

/*
*   Заголовок страниц (Основной H1)
*/


type IPageTitleProps = {
    children: ReactNode,
    sx?: SxProps<Theme>,
}

export function PageTitle({
    children,
    sx = {},
}: IPageTitleProps) {

    return (
        <Typography
            component='h1'
            variant='h4'
            sx={{ mb: 2, ...sx }}
        >
            {children}
        </Typography>
    );
}